import BaseDataProcessor from './baseDataProcessor';

export default class GroupComparisonDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData) {
    super();

    this.apiStatisticsData = apiStatisticsData;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    return [];
  }

  get chartData() {
    if (this.apiStatisticsData) {
      const { groups } = this.apiStatisticsData;

      return groups.map((item) => ({ x: item.group.name, y: item.pointsAvg })).sort((itemA, itemB) => itemB.y - itemA.y);
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/groupComparisonDataProcessor.js